import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import appstore from "../images/appstore.png";
import chplay from "../images/chplay.png";
import Logo from "../images/logoApp.png";

import background from "../images/background.jpg";
import LazyLoad from "react-lazy-load";
import { ToastContainer } from "react-toastify";
import Footer from "../layout/Footer";
import { useAuth } from "../context/AuthContext";

const AuthLayout = () => {
  const { isLoggedIn, loading } = useAuth();

  // Hiển thị loading trong khi kiểm tra authentication
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-900">
        <div className="text-center">
          <div className="loading-spinner animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-green-500 mx-auto mb-4"></div>
          <p className="text-white text-lg">Đang tải...</p>
        </div>
      </div>
    );
  }

  // Nếu đã đăng nhập, redirect về trang services
  if (isLoggedIn) return <Navigate to="/services" />;

  const circleLeft = {
    width: "100%",
    height: "100%",
    clipPath: "circle(70% at 25% 0%)",
    background: "#008748B2",
  };

  const circleRight = {
    width: "100%",
    height: "100%",
    clipPath: "circle(38% at 93% 15%)",
    background: "rgba(20, 145, 87, .9)",
    position: "absolute",
    top: "0",
    right: "0",
  };

  return (
    <>
      <section
        className=" flex flex-col justify-between w-full min-h-screen mobile:hidden"
        style={{ background: `no-repeat center/cover url(${background})` }}
      >
        <div className="flex flex-col justify-center items-center mt-[100px] relative top-[-150px]">
          <LazyLoad>
            <>
              <img
                src={Logo}
                alt="Your"
                className="w-[400px] tablet:w-[200px]"
              />
            </>
          </LazyLoad>
          <h1 className="font-bold text-white text-7xl ipad:text-4xl tablet:text-4xl">
            Kết Nối Yêu Thương
          </h1>
          <div className="flex justify-center items-center mt-[30px]">
            <a href="#" className="">
              <LazyLoad>
                <>
                  <img src={appstore} alt="appstore" className="w-[200px]" />
                </>
              </LazyLoad>
            </a>
            <a href="#" className="">
              <LazyLoad>
                <>
                  <img
                    src={chplay}
                    alt="chplay"
                    className="w-[230px] h-[100px]"
                  />
                </>
              </LazyLoad>
            </a>
          </div>
        </div>
        <Outlet />
        <Footer />
      </section>

      <section className="mobile:flex flex-col hidden font-roboto min-h-screen w-full relative">
        <div className="h-[33vh] relative">
          <div style={circleLeft}></div>
          <div style={circleRight}></div>

          <div className="absolute top-1/2 -translate-y-3/4 left-[10%]">
            <div>
              <LazyLoad>
                <>
                  <img src={Logo} alt="logo" />
                </>
              </LazyLoad>
            </div>
            <h1 className="text-lg font-light text-white">
              Kết nối yêu thương
            </h1>
          </div>
        </div>

        <Outlet />
        <Footer />
      </section>
      <ToastContainer />
    </>
  );
};

export default AuthLayout;
